import { sectionRoutes } from '../helpers';

export const TELEPHONY_ROUTES = sectionRoutes({
  meta: { adminTab: 'Telephony' },
  tabKey: 'telephonyTab',
  routes: [
    ['telephony', 'AdminTelephony', 'address_book'],
    ['telephony/address-book', 'AdminTelephonyAddressBook', 'address_book'],
    ['telephony/call-types', 'AdminTelephonyCallTypes', 'call_types'],
    ['telephony/participant-roles', 'AdminTelephonyParticipantRoles', 'participant_roles'],
    ['telephony/phone-numbers', 'AdminTelephonyPhoneNumbers', 'phone_numbers'],
  ],
});
